var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationCourt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 41h8V23h-8v18zm-2 2h12V21H52v22z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 49H52c-2.206 0-4-1.794-4-4s1.794-4 4-4v2c-1.103 0-2 .897-2 2s.897 2 2 2h12c1.103 0 2-.897 2-2s-.897-2-2-2v-2c2.206 0 4 1.794 4 4s-1.794 4-4 4M64 23v-2c1.103 0 2-.897 2-2s-.897-2-2-2H52c-1.103 0-2 .897-2 2s.897 2 2 2v2c-2.206 0-4-1.794-4-4s1.794-4 4-4h12c2.206 0 4 1.794 4 4s-1.794 4-4 4M53 31h-3.236l-2-1H18v-2h30.236l2 1H53v2M48.236 36H18v-2h29.764l2-1H53v2h-2.764l-2 1",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 10c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 58h-2v-2a1 1 0 00-1-1H49a1 1 0 00-1 1v2h-2v-2c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 59a1 1 0 00-1 1v2a1 1 0 001 1h22a1 1 0 001-1v-2a1 1 0 00-1-1H47zm22 6H47c-1.654 0-3-1.346-3-3v-2c0-1.654 1.346-3 3-3h22c1.654 0 3 1.346 3 3v2c0 1.654-1.346 3-3 3z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M8 65h39v-2H8zM57 29h2v-2h-2zM57 33h2v-2h-2zM57 37h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationCourt;